import { Button, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

import { useAppSelector, useCrossPopup } from 'shared/lib';

import { selectSmsCodeIssueInfoModal } from 'features/BankAccountOpened/model';

import styles from './SmsCodeIssueInfoModal.module.scss';

interface IBankAccountOpenedModalProps {
  visible: boolean;
  onClose: () => void;
}

export const SmsCodeIssueInfoModal: React.FC<IBankAccountOpenedModalProps> = ({ visible, onClose }) => {
  const Popup = useCrossPopup();
  const { title, phoneNumber, text, buttons } = useAppSelector(selectSmsCodeIssueInfoModal);
  const isMobile = useIsMobile();

  return (
    <Popup
      className={styles.modal}
      onClose={onClose}
      visible={visible}
    >
      <Popup.Header title={title} />
      <Popup.Content>
        <Space
          direction="vertical"
          size={24}
        >
          <Space
            direction="vertical"
            size={12}
          >
            <Typography.Text
              size={16}
              className="h-color-D60"
            >
              {text}
            </Typography.Text>
            <Typography.Link
              href={phoneNumber?.hrefNumber}
              strong
            >
              {phoneNumber?.phoneNumber}
            </Typography.Link>
          </Space>

          <Space>
            {buttons.map((button) => (
              <Button
                block={isMobile}
                onClick={onClose}
                key={button.title}
                variant={button.type}
              >
                {button.title}
              </Button>
            ))}
          </Space>
        </Space>
      </Popup.Content>
    </Popup>
  );
};
